/**
 * Enum da Condição do Ativo no Mapa de Atenção dos Ativos.
 *
 * Vem dos alarmes atuados, mais **Fora de Operação**, que é o Ativo sem
 * monitoramento algum ligado. Não confundir com `assetState`, que é o Estado do
 * Ativo do Painel de Status de Comunicação: um Ativo tem os dois ao mesmo tempo
 * e eles discordam com frequência. Ver
 * docs/adr/0009-condicao-do-ativo-separada-do-estado-do-ativo.md e
 * docs/adr/0013-mapa-de-atencao-sem-comunicacao.md
 */
export const assetConditions = {
  CRITICAL: 'critical',
  ATTENTION: 'attention',
  OUT_OF_SERVICE: 'out-of-service',
  NORMAL: 'normal',
};

/**
 * Condições da mais grave para a menos grave.
 *
 * Reparte o anel do Agrupamento do Mapa.
 *
 * Fora de Operação vem antes de Normal: monitoramento desligado é pendência de
 * alguém.
 */
export const assetConditionsBySeverity = [
  assetConditions.CRITICAL,
  assetConditions.ATTENTION,
  assetConditions.OUT_OF_SERVICE,
  assetConditions.NORMAL,
];


export default assetConditions;
